export const BASE_URL = process.env.BASE_URL ?? `${window.location.protocol}//${window.location.host}`;